module.exports = __webpack_public_path__ + "img/cartoon1.9eccfb73.jpg";